import { AnswerData, QuizAnswer, QuizSubmission } from "../types/api"
import { Quiz } from "../types/quiz"

const getAnswerData = (questionId: number): AnswerData => {
    const questionData = window.digitalData &&
        window.digitalData.page &&
        window.digitalData.page.careerQuiz &&
        window.digitalData.page.careerQuiz['question_' + questionId];

    return {
        answer: questionData?.answers,
        timeSpent: questionData?.timeSpent,
    }
}

const convertAnswers = (quiz: Quiz): QuizAnswer[] =>
    quiz.questions.map(question => {
        const answerData = getAnswerData(question.id);

        return {
            question_id: question.uuid,
            answer_value: answerData?.answer,
            answer_type: question.api_type,
            time_spent_seconds: answerData?.timeSpent,
        };
    });

const convertAnalyticsToApi = (quiz: Quiz): QuizSubmission => {
    return {
        quiz_id: quiz.uuid,
        // submission_timestamp: (new Date()).toJSON(),
        answers: convertAnswers(quiz),
        metadata: {
            client_version: quiz.version,
            user_agent: window && window.navigator && window.navigator.userAgent, 
        },
        final_result: window.digitalData && window.digitalData.page && window.digitalData.page.careerQuiz && window.digitalData.page.careerQuiz["final_result"],
    };
};

export const persistToApi = async (quiz: Quiz): Promise<void> => {
    const submissionData = convertAnalyticsToApi(quiz);

    try {
        fetch('/api/v1/submit-quiz', {
            method: 'POST',
            body: JSON.stringify(submissionData),
        });
    } catch(e) {}
};